<div class="row marginRow">
  <p>
    {{'PolicyHolder.PolicyHolderInfo' | translate}}
  </p>

  <app-toggle-input appConfigSettingsInput class="full-width" placeholder="PolicyHolder.IsSecondPolicyHolder"
    [form]="policyHolderFormGroup" [optionsList]="yesNoList" [control]="policyHolderFormGroup.get('isPolicyHolder')">
  </app-toggle-input>
</div>

<ng-container *ngIf="policyHolderFormGroup.value.isPolicyHolder == OptionsEnum.Yes">
  <div class="row marginRow">
    <div class="secondTitle">
      <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.PremiumSplit' | translate}}</h2>
    </div>

    <p>
      {{'AdditionalInformation.PremiumSplit' | translate}}
    </p>

    <app-toggle-input appConfigSettingsInput class="full-width secondToggle" placeholder="PremiumPayer.PremiumSplit"
      [form]="policyHolderFormGroup" [optionsList]="yesNoList" [control]="policyHolderFormGroup.get('premiumSplit')">
    </app-toggle-input>
  </div>
</ng-container>
